<template>
  <baseEdit />
</template>

<script>
  import baseEdit from './baseEdit';

  export default {
    name: 'collectBillAdd',
    components: {
      baseEdit,
    },
  };
</script>
